"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AvatarWithFlyout = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _lodestarUtils = require("@smartsheet/lodestar-utils");
var _react = _interopRequireWildcard(require("react"));
var _Avatar = require("../../avatar/Avatar");
var _flyout = require("../../flyout");
var _useDelayedOpen = require("../../flyout/hooks/useDelayedOpen");
var _applyMaxHeightModifier = require("../../menu/hooks/applyMaxHeightModifier");
var _checkMaxHeightModifier = require("../../menu/hooks/checkMaxHeightModifier");
var _AvatarGroupFlyoutContainer = require("../components/AvatarGroupFlyoutContainer");
var _AvatarWrap = require("../styled/AvatarWrap");
var _AvatarGroupProvider = require("./AvatarGroupProvider");
const avatarSize = {
  20: "xxSmall",
  24: "xSmall",
  32: "medium"
};
const handleOpenAndClose = function (callback, requireKeyboardToggle) {
  let id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  return () => {
    if (!requireKeyboardToggle) {
      callback(id);
    }
  };
};
const AvatarWithFlyout = _ref => {
  let {
    "aria-label": ariaLabel,
    color,
    email,
    flyoutContents,
    id,
    imgSrc,
    initials,
    showRing,
    size,
    requireKeyboardToggle,
    portalProps
  } = _ref;
  const avatarRef = (0, _react.useRef)(null);
  const isOverflowAvatar = id.substring(0, 8) === "overflow";
  const {
    raf
  } = (0, _lodestarUtils.useRequestAnimationFrame)();
  const {
    userState,
    setSpecificUserToOpen,
    closeAll
  } = (0, _react.useContext)(_AvatarGroupProvider.AvatarGroupContext);

  // Not using useFocusMode here because we have a slightly different use-case.
  const userMode = (0, _react.useRef)("mouse");
  const {
    getDelayedOpenTargetProps
  } = (0, _useDelayedOpen.useDelayedOpen)({
    delayMode: "batch",
    exitDelay: 250,
    onCloseCallback: handleOpenAndClose(closeAll, requireKeyboardToggle),
    onOpenCallback: handleOpenAndClose(setSpecificUserToOpen, requireKeyboardToggle, id)
  });
  const isFlyoutOpen = (0, _react.useMemo)(() => userState.find(user => user.id === id)?.isOpen ?? false, [userState, id]);
  const {
    flyoutProps,
    targetProps
  } = (0, _flyout.useFlyout)({
    isOpen: isFlyoutOpen,
    onCloseRequested: () => {
      // This will only get called when the user presses escape to close the contact Flyout.
      // We should allow this for a11y, but if they refocus/re-hover we should reopen it.
      closeAll();
    },
    portalProps: portalProps,
    popperProps: {
      modifiers: [
      // These modifiers ensure the Flyout doesn't grow any taller than the screen.
      {
        name: "preventOverflow"
      }, _checkMaxHeightModifier.checkMaxHeightModifier, _applyMaxHeightModifier.applyMaxHeightModifier]
    },
    placement: "bottom-end",
    offset: {
      distance: 4
    },
    components: {
      FlyoutContainer: _AvatarGroupFlyoutContainer.AvatarGroupFlyoutContainer
    },
    targetRef: avatarRef
  });
  const {
    // Pull these out and apply them to the Avatar's parent element so the Flyout can be
    // included in the React component tree. This allows the user to mouse over the contact cards
    // without them closing immediately.
    onMouseEnter,
    onMouseLeave,
    ...delayedOpenProps
  } = getDelayedOpenTargetProps({
    ...targetProps,
    onFocus: () => {
      userMode.current = "keyboard";
      if (requireKeyboardToggle) closeAll();
    },
    onMouseEnter: () => {
      if (userMode.current === "keyboard") {
        // if in keyboard mode, remove focus from avatar now so mouse move to flyout will not cause
        //  delayed avatar blur to close the flyout.
        const {
          activeElement
        } = document;
        // only unfocus if this is an Avatar (right now, just check that I'm a div as that's all we have)
        if (activeElement && activeElement instanceof HTMLDivElement) {
          activeElement.blur?.();
        }
      }
      userMode.current = "mouse";
      if (isOverflowAvatar) {
        setSpecificUserToOpen(id);
      }
    }
  });
  return /*#__PURE__*/_react.default.createElement(_AvatarWrap.AvatarWrap, {
    size: size
    // We have a wrapper here so the Flyout is included in the React component tree. This
    // allows the user to mouse over the contact cards without them closing immediately.
    // These mouse events need to be on the wrapper.
    ,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  }, /*#__PURE__*/_react.default.createElement(_Avatar.Avatar, (0, _extends2.default)({}, delayedOpenProps, {
    size: avatarSize[size]
    // Generally we want to use the email prop, but for the AvatarGroup, the overflow
    // Avatar will use the neutral color manually.
    ,
    color: color,
    email: email,
    "aria-label": ariaLabel,
    initials: initials,
    src: imgSrc,
    showRing: showRing,
    onKeyDown: e => {
      if (requireKeyboardToggle && (e.key === "Enter" || e.key === " ")) {
        // Enter and space should open the Flyout.
        setSpecificUserToOpen(id);
      }
    }
  })), /*#__PURE__*/_react.default.createElement(_flyout.Flyout, (0, _extends2.default)({}, flyoutProps, {
    ref: element => {
      if (element && requireKeyboardToggle && userMode.current === "keyboard") {
        raf(() => {
          element.focus();
        });
      }
    }
  }), flyoutContents));
};
exports.AvatarWithFlyout = AvatarWithFlyout;
//# sourceMappingURL=AvatarWithFlyout.js.map